import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import IntrepidIcon from 'components/icons/third-party/Intrepid'
import VideoIcon from 'components/icons/Video'
import InfoCircleIcon from 'components/icons/InfoCircle'

import './styles.css'

class DayDisplay extends Component {
  static propTypes = {
    descr: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    activities: PropTypes.array,
    // eslint-disable-next-line react/forbid-prop-types
    media: PropTypes.object,
    openMedia: PropTypes.func.isRequired,
    dayNum: PropTypes.number.isRequired,
  }

  static defaultProps = {
    descr: 'TBC',
    activities: [],
    media: undefined,
  }

  render() {
    const { descr, activities, media, openMedia, } = this.props

    const descrItems = descr.split(';')
    let activityIcon = ''
    if (descr === 'TBC') {
      return <div className="day-display-container">TBC</div>
    }
    if (activities.length) {
      // assumes one activity and always intrepid (for now)
      const { name, link, day, } = activities[0]
      const activityTitle = `${name} - ${day}`
      activityIcon = (
        <div className="activity-icon">
          <a href={link} target="_blank" title={activityTitle}>
            <div className="day">{day}</div>
            <IntrepidIcon width={50} />
          </a>
        </div>
      )
    }

    let videoLinks,
      blogLinks
    if (media) {
      if (media.video && media.video.length) {
        videoLinks = media.video.map(id => (
          <button
            className="video-link"
            key={id}
            onClick={() => {
              openMedia({ mediaId: id, })
            }}
          >
            <VideoIcon />
          </button>
        ))
      } else if (media.blog && media.blog.length) {
        blogLinks = media.blog.map(id => (
          <button
            className="blog-link"
            key={id}
            onClick={() => {
              openMedia({ mediaId: id, })
            }}
          >
            <InfoCircleIcon />
          </button>
        ))
      }
    }

    return (
      <div className="day-display-container">
        {activityIcon}
        <div className="day-items--listing">
          <ul>
            {descrItems.map((item, index) => (
              <li key={item + index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="day-items--media">
          {videoLinks}
          {blogLinks}
        </div>
      </div>
    )
  }
}

export default DayDisplay



// WEBPACK FOOTER //
// ./src/components/DayDisplay/component.js